/** The HTTPS clone URL of a repository on a forge (`github.com`, `acme/app`). */
export function repositoryCloneUrl(repository: { host: string; fullName: string }): string {
  return `https://${repository.host}/${repository.fullName}.git`;
}

/** The forge repository a clone URL names: the inverse of `repositoryCloneUrl`. */
function repositoryOfCloneUrl(repositoryUrl: string): { host: string; fullName: string } {
  const url = new URL(repositoryUrl);
  return { host: url.host, fullName: url.pathname.replace(/^\/+/, '').replace(/\.git$/, '') };
}

export function repositoryWorkspaceRoot(repositoryUrl: string): string {
  return `/workspace/repository/${repositoryOfCloneUrl(repositoryUrl).fullName}`;
}

/**
 * Whether a task's workspace is a Git checkout of a cloud project; otherwise a folder without
 * Git, kept as archives.
 */
export function cloudTaskIsGit(task: { projectId: string | null }): boolean {
  return task.projectId !== null;
}

/** The checkout of a folder project: a folder of a machine with no forge repository. */
export function localWorkspaceRoot(name: string): string {
  const slug = name.replace(/[^A-Za-z0-9._-]+/g, '-').replace(/^[-.]+|-+$/g, '') || 'workspace';
  return `/workspace/repository/local/${slug.slice(0, 80)}`;
}

export function cloudWorkspaceNeedsRestore(input: {
  git: boolean;
  repositoryUrl: string | null;
  workspaceRoot: string;
  runtimeCreated: boolean;
  runtimeResumed?: boolean;
  hasCheckpoint?: boolean;
}): boolean {
  if (!input.git) {
    return input.hasCheckpoint === true && (input.runtimeCreated || input.runtimeResumed === true);
  }
  return (
    input.runtimeCreated ||
    input.runtimeResumed === true ||
    (input.repositoryUrl !== null &&
      input.workspaceRoot !== repositoryWorkspaceRoot(input.repositoryUrl))
  );
}

export function cloudHandoffPublishedBranch(
  requestedRef: string | undefined,
  defaultBranch: string,
): string | null {
  return requestedRef !== undefined && requestedRef !== defaultBranch ? requestedRef : null;
}
